import React from 'react';
  
function About() {  
  return (  
    <div>关于网站</div>
  );  
}  

export default About;